import { createContext, useCallback, useContext, useMemo, useState } from "react";

const ModalWorkFlowContext = createContext();

export function useModalWorkFlow() {
  const context = useContext(ModalWorkFlowContext);
  return context;
}

export default function ModalWorkFlowProvider({ children, defaultView = 1 }) {
  /**
   * This doesn't support history atm.
   * So it only makes sense to use this if the views all stem from the first
   * I.e. user action in the default view is required to get to another.
   *
   * If not then we'll need history state to know where the back arrow should go back to.
   */

  const [state, setState] = useState({
    view: defaultView,
    state: {}
  });

  const view = state.view;

  const setView = useCallback(
    (view, _s) => {
      setState(prevState => ({
        ...prevState,
        state: {
          ...prevState.state,
          ..._s
        },
        view
      }));
    },
    [setState]
  );

  const _state = state.state;

  const api = useMemo(
    () => ({
      view,
      setView,
      defaultView,
      state: _state
    }),
    [view, setView, defaultView, _state]
  );
  return <ModalWorkFlowContext.Provider value={api}>{children}</ModalWorkFlowContext.Provider>;
}
